import { atom } from 'recoil';

const LoadingState = atom({
    key: 'loadingState',
    default: false
});

export default LoadingState;